import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Localfile } from '../../interfaces/localfile.modal';

@Injectable()
export class LocalfileProvider {

  localfiles: Localfile[];

  constructor(public http: HttpClient, public storage: Storage) {
    this.localfiles = [];
  }

  getLocalFiles() {
    return new Promise<Localfile[]>((resolve, reject) => {
      this.storage.get("localfiles").then((data:Localfile[]) => {
        if(data == null){
          this.localfiles = [];
        } else {
          this.localfiles = data;
        }
        resolve(this.localfiles);
      });
    });
  }

  updateLocalFilesInStorage() {
    this.storage.set("localfiles", this.localfiles);
  }

  createLocalFile(localfile, fileInfos){
    console.log("CREATE LOCAL FILE");
    let newFile:Localfile = {
      id: this.generateID(),
      name: localfile.AssetName,
      date: fileInfos.fileDate,
      fileName: fileInfos.fileName,
      filePath: fileInfos.filePath,
      fileType: "localfiles",
      thumbnail: localfile.Thumbnail,
      IsSharable: localfile.IsSharable,
      assetId: localfile.AssetId,
      ThumbnailWidth: localfile.ThumbnailWidth,
      ThumbnailHeight: localfile.ThumbnailHeight
    }
    if(localfile.thumbLocalUrl){
      newFile.thumbLocalUrl = localfile.thumbLocalUrl;
    }

    this.localfiles.push(newFile);
    this.updateLocalFilesInStorage();
  }

  generateID(){
    let id = 0;
    let localfiles = this.localfiles;
    if(localfiles.length > 0){
      let lastId = localfiles[localfiles.length - 1].id;
      id = lastId+1;
    } else {
      id = 1;
    }
   return id; 
  }

  updateLocalfileList(synchroListAssets){
    return new Promise((resolve, reject) => {
      this.searchInUpdatedArr(synchroListAssets.Updated)
      .then(() => this.searchInDeletedArr(synchroListAssets.Deleted)
        .then(() => {
          this.storage.set("localfiles", this.localfiles).then(data => {
            resolve(data);
          });
      }))
    });
  }

  searchInDeletedArr(deletedSyncList){
    return new Promise((resolve, reject) => {
      if(deletedSyncList.length > 0 ) {
        this.localfiles = this.localfiles.filter(localfile => {
          return (deletedSyncList.indexOf(localfile.assetId) == -1)
        });
        resolve(this.localfiles);
      } else {
        resolve();
      }
    });
  }

  searchInUpdatedArr(updatedSyncList){
    return new Promise((resolve, reject) => {
      if(updatedSyncList.length > 0){
        let updatedAssetIds = updatedSyncList.map(asset => {return asset.AssetId});
        console.log(updatedAssetIds);
        console.log(this.localfiles);
        this.localfiles = this.localfiles.filter(localfile => {
          return (updatedAssetIds.indexOf(localfile.assetId) == -1)
        });
        console.log(this.localfiles);
        resolve(this.localfiles);
      } else {
        resolve();
      }
    });
  }

  getLocalfileDataByAssetId(assetId){
    return this.localfiles.filter(localfile => { return (localfile.assetId == assetId)});
  }

  removeLocalfile(openLocalfile){
    return new Promise((resolve, reject) => {
      if(this.localfiles.length > 0) {
        let found = this.localfiles.findIndex(item => item.id == openLocalfile.id);
        if(found !== -1){
          this.localfiles.splice(found, 1);
          this.updateLocalFilesInStorage();
          resolve("Remove localfile successfully");
        }
      }
      else {
        reject("no localfiles");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/localfile/localfile.ts